import React from 'react'
import OCRWrapper from '@/modules/document/components/file-info/ocr-wrapper'
import { CurrencyInput } from '@/modules/base/components/inputs'
import { dispatch } from '@/redux/ducks/lists'
import { updateDocument } from '@/redux/ducks/document/drawer'
import DocumentReadOnlyField from './read-only'
import { formatMoney } from '@/modules/react/util'
import { useAppSelector } from '@/redux/store'
import { EXTERNAL_OWNER_SYSTEMS } from '@/modules/file/constants'

interface DocumentCurrencyInputProps {
  label: string,
  value: number | null,
  readOnly?: boolean,
  ocrKey?: string,
  name?: string,
  customClass?: object | string,
  isOcrValue?: boolean,
}

const DocumentCurrencyInput = (props: DocumentCurrencyInputProps) => {
  const document = useAppSelector((state) => state.document.drawer.document)

  const {
    isAssigned,
    externalOwnerSystem,
    metaData,
  } = document

  const { customClass, label, value, ocrKey, name, readOnly, isOcrValue } = props
  const formatter = (v) => formatMoney(v, { symbol: '€', precision: 2, decimal: ',', thousand: '.' })

  if (isAssigned || externalOwnerSystem === EXTERNAL_OWNER_SYSTEMS.desktop) {
    return <DocumentReadOnlyField label={label} value={formatter(value)} customClass={customClass} />
  }

  return (
    <OCRWrapper ocr={metaData?.ocr} ocrKey={ocrKey} valueKey={name} isOcrValue={isOcrValue}
      className={customClass} customClass={customClass}>
      <CurrencyInput
        dataQsId='documentCurrencyInput'
        decimal=','
        thousand='.'
        precision={2}
        readOnly={readOnly}
        name={name}
        useFormik={false}
        label={label}
        value={value}
        onBlur={(value) => dispatch(updateDocument({ value, key: name }))}
      />
    </OCRWrapper>
  )
}

export default DocumentCurrencyInput
